import React from "react";
import trans, { isRTL } from "../../../../utils";
import { color } from "@codemirror/theme-one-dark";

const HeatMapRow = ({ title, value, type }) => {
  const cssType = () => {
    if (type === "name") {
      return { color: "#2E9245", fontWeight: "600", fontSize: "14px" };
    } else if (type === "rate") {
      return {
        color: "#10B981",
        fontWeight: "500",
        fontSize: "14px",
        paddingBlock: "4px",
        paddingInline: "8px",
        borderRadius: "4px",
      };
    } else {
      return { color: "#42526E", fontSize: "14px" };
    }
  };
  return (
    <>
      <div
        className="col-lg-6"
        style={{
          color: "#42526E",
          marginBottom: "8px",
          fontSize: "14px",
          textTransform: "capitalize",
        }}
      >
        {trans(title)}:
      </div>
      <div className="col-lg-6" style={cssType()}>
        {value}
      </div>
    </>
  );
};

export default function HeatMapPopupBody({ data }) {
  return (
    <div
      className="device-popup-body"
      style={{ overflowY: "scroll" }}
      dir={isRTL ? "rtl" : "ltr"}
    >
      {data.map((m, i) => (
        <div key={i} className="row">
          <HeatMapRow title="POIs Name" value={m?.poiName} type="name" />
          <HeatMapRow title="total tasks" value={m?.taskCount} />
          <HeatMapRow title="inProgress" value={m?.inProgress} />
          <HeatMapRow title="pending" value={m?.todo} />
          <HeatMapRow title="completed" value={m?.done} />
          <HeatMapRow
            title="completion rate"
            value={`${
              m?.taskCount ? ((m?.done / m?.taskCount) * 100).toFixed(0) : 0
            }%`}
            type="rate"
          />
          <hr
            style={{
              width: "285px",
              margin: "auto",
              marginBlock: "16px",
              color: "#D2D5DCss",
            }}
          />
        </div>
      ))}
    </div>
  );
}
